// extracted by mini-css-extract-plugin
export var brand = "_27-9";
export var compact = "_27-6";
export var extraSmall = "_27-7";
export var icon = "_27-0";
export var large = "_27-4";
export var light = "_27-1";
export var medium = "_27-5";
export var outline = "_27-b";
export var primaryDark = "_27-a";
export var primaryLight = "_27-8";
export var primaryModern = "_27-c";
export var success = "_27-2";
export var successSolid = "_27-3";